import { IUserRepository } from "../business/IUserRepository";
import User, { VehicleTypeBasedInterface, VehicleTypeFeeRule } from "../business/User";
import ApiService from "../../core/presentation/services/ApiService";
import { injectable } from "inversify-sugar";
import { VehicleInfo } from "fleet/business/Fleet";

@injectable()
class UserRepository implements IUserRepository {
  public async acceptTerms(): Promise<User | any> {
    try {
      const response: any = await ApiService.setPost("auth/agree-terms", "");
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  }
  public async getAllDriverDevices(): Promise<any> {
    try {
      const response: any = await ApiService.getPost("device/drivers", "");
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public async getAllRolesList(page: number, input: string, filter: string): Promise<any> {
    try {
      const response: any = await ApiService.getPost(page > 0 ? `roles/created?page=${page}&limit=10${input ? `&search=${input}` : ""}${filter ? `&${filter}` : ""}` : `roles/created${filter ? `?${filter}` : ""}`, "");
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public async getAllPermissionsList(): Promise<any> {
    try {
      const response: any = await ApiService.getPost("roles/permissions", "");
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public async assignPermissions(values: any): Promise<any> {
    try {
      const response: any = await ApiService.updatePost(`roles/assign-permissions`, values);
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public async getRolePermission(id: any): Promise<any> {
    try {
      const response: any = await ApiService.getPost(`roles/${id}`, "");
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public async getAllDeviceLocation(tripId: any): Promise<any> {
    try {
      const response: any = await ApiService.setPost("/device/location", tripId);
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public async reverseGeoCode(values: any): Promise<any> {
    try {
      const response = await ApiService.setPost("device/reverse-geocode", values);
      return response || {};
    } catch (error) {
      Promise.reject(error);
    }
  }

  public async setPassword(values: any): Promise<User | any> {
    try {
      const response: any = await ApiService.setPost("auth/password", values);
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async setAuthUserPassword(values: any): Promise<User | any> {
    try {
      const response: any = await ApiService.setPost("auth/user-password", values);
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async updateAuthMethod(values: any): Promise<User | any> {
    try {
      const response: any = await ApiService.updatePost("auth/login-method", values);
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async setIsFirstLogin(values: any): Promise<User | any> {
    try {
      const response: any = await ApiService.getPost("users/firstLogin", "");
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async logout(id: any, values: any): Promise<any> {
    try {
      const response: any = await ApiService.updatePost(`/users/log-out`, values);
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public async getRefreshToken(): Promise<User | any> {
    try {
      const response: any = await ApiService.getPost("auth/refresh", "");
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  }
  public async createOtp(values: any): Promise<User> {
    const response: any = await ApiService.setPost("auth/createotp", values);

    return response?.data || {};
  }

  public async verifyNumber(values: any): Promise<User | any> {
    try {
      const response: any = await ApiService.setPost("auth/verify-code", values);
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async resetPassword(values: any): Promise<User | any> {
    try {
      const response: any = await ApiService.setPost("auth/reset-password", values);
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async verifyUsername(values: any): Promise<User | any> {
    try {
      const response: any = await ApiService.setPost("auth/verify-reset-password", values);
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async sendCode(values: any): Promise<User | any> {
    try {
      const response: any = await ApiService.setPost("auth/send-code", values);
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async loginWithPassword(values: any): Promise<any> {
    try {
      const response = await ApiService.setPost("auth/login", values);
      return response || {};
    } catch (error) {
      Promise.reject(error);
    }
  }

  public async signup(values: any): Promise<User> {
    try {
      const response: any = await ApiService.setPost("auth/shipper-signup", values);
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async vehicleOwnerSignup(values: any): Promise<User> {
    try {
      const response: any = await ApiService.setPost("auth/vehicle-owner-signup", values);
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async login(values: any): Promise<any> {
    try {
      const response = await ApiService.setPost("auth/federate", values);
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }
  public async verifyEmail(values: any): Promise<any> {
    try {
      const response = await ApiService.setPost("auth/verify-email", values);
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }
  public async createPlatformAdmin(values: any): Promise<any> {
    try {
      const response: any = await ApiService.setPost("users/new-user", values);
      return response.data;
    } catch (error) {
      return error;
      // Promise.reject(error);
    }
  }

  public async getAllPlatformAdmin(page: number, input: string, filter: string): Promise<any> {
    try {
      const response: any = await ApiService.getPost(page > 0 ? `/users/new-user?page=${page}&limit=10${input ? `&search=${input}` : ""}${filter ? `&${filter}` : ""}` : `users/new-user${filter ? `?${filter}` : ""}`, "");
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public async getAPlatformAdmin(id: any): Promise<any> {
    try {
      const response: any = await ApiService.getPost(`users/platform-admin/${id}`, "");
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public async deletePlatformAdmin(id: any): Promise<any> {
    try {
      const response: any = await ApiService.deletePost(`users/new-user/${id}`, "");
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public async updatePlatformAdmin(id: any, values: any): Promise<any> {
    try {
      const response: any = await ApiService.updatePost(`users/new-user/${id}`, values);
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }

  // Userr Profile
  public async getUserProfile(): Promise<any> {
    try {
      const response: any = await ApiService.getPost("auth/profile", "");
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async updateOwnProfile(values: any): Promise<any> {
    try {
      const response: any = await ApiService.updatePost("auth/profile", values);
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async additonalInfoVehicleOwner(values: any, id: number): Promise<any> {
    try {
      const response: any = await ApiService.updatePost(`users/additional-information/${id}`, values);
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async updateUserProfile(values: any): Promise<any> {
    try {
      const response: any = await ApiService.updatePost("/auth/shippers", values);
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }
  public async getAdministrativeDivision(): Promise<any> {
    try {
      const response: any = await ApiService.getPost("public/administrative-divisions", "");
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }
  public async updatePassword(values: any): Promise<User | any> {
    try {
      const response: any = await ApiService.updatePost("auth/password", values);
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async getShipper(): Promise<any> {
    try {
      const response: any = await ApiService.getPost("auth/shippers", "");
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  // Users
  // Vehicle Owner
  public async getAllVechileOwner(): Promise<any> {
    try {
      const response: any = await ApiService.getPost("auth/vehicle-owners?page=1&limit=10&isLoggedIn=true", "");
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public async getAllNewVechileOwner(page: number, input: string, filter: string, report: string, isLoggedIn?: boolean, limit?: number): Promise<any> {
    try {
      let baseUrl = `auth/vehicle-owners?page=${page}`;
      if (limit) {
        baseUrl += `&limit=${limit}`;
      }
      if (isLoggedIn) {
        baseUrl += `&isLoggedIn=true`;
      }
      if (input) {
        baseUrl += `&search=${input}`;
      }
      if (filter) {
        baseUrl += `&${filter}`;
      }
      if (report) {
        baseUrl += `&${report}`;
      }

      const response: any = await ApiService.getPost(baseUrl, "");
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public async getNoOfVehicles(): Promise<any> {
    try {
      const response: any = await ApiService.getPost(`/vehicle/vehicle-number`, "");
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public async createVechileOwner(values: any): Promise<any> {
    try {
      const response: any = await ApiService.setPost("users", values);
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public async getVehicleTypeBasedRule(): Promise<any> {
    try {
      const response: any = await ApiService.getPost(`rule/vehicle-type`, "");
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public async updateVehicleTypeBasedRule(value: any): Promise<any> {
    try {
      const response: any = await ApiService.updatePost(`rule/vehicle-type`, value);
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public async deleteVehicleTypeRule(id: number): Promise<any> {
    try {
      const response: any = await ApiService.deletePost(`rule/vehicle-type/${id}`, "");
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public async addDistanceBasedFee(values: any): Promise<any> {
    try {
      const response: any = await ApiService.setPost("rule/distance-based", values);
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public async editDistanceBasedFee(values: any): Promise<any> {
    try {
      const response: any = await ApiService.updatePost(`rule/distance-based`, values);
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public async deleteAllDistanceBasedFee(): Promise<any> {
    try {
      const response: any = await ApiService.deletePost(`rule/distance-based`, "");
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public async switchDistanceBasedFee(value: any): Promise<any> {
    try {
      const response: any = await ApiService.setPost(`rule/status`, value);
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public async getAllDistanceBasedFee(): Promise<any> {
    try {
      const response: any = await ApiService.getPost(`rule/distance-based`, "");
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public async getPercentageBasedFee(): Promise<any> {
    try {
      const response: any = await ApiService.getPost(`rule/percentage-based`, "");
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public async addPercentageBasedFee(value: any): Promise<any> {
    try {
      const response: any = await ApiService.setPost(`rule/percentage-based`, value);
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public async switchPercentageBasedFee(value: any): Promise<any> {
    try {
      const response: any = await ApiService.setPost(`rule/status`, value);
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }

  // incremental based

  public async getIncrementalBasedFee(): Promise<any> {
    try {
      const response: any = await ApiService.getPost(`rule/incremental-based`, "");
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public async addIncrementalBasedFee(value: any): Promise<any> {
    try {
      const response: any = await ApiService.setPost(`rule/incremental-based`, value);
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public async switchIncrementalBasedFee(value: any): Promise<any> {
    try {
      const response: any = await ApiService.setPost(`rule/status`, value);
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public async addMaxSpeed(values: any): Promise<any> {
    try {
      const response: any = await ApiService.setPost("/vehicle/speed-limit", values);
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public async getSpeedData(): Promise<any> {
    try {
      const response: any = await ApiService.getPost(`vehicle/speed-limit`, "");

      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public async getAUser(id: any): Promise<any> {
    try {
      const response: any = await ApiService.getPost(`users/${id}`, "");
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public async getVehiclesOfVehicleOwner(contactNumber: number, page: number): Promise<any> {
    try {
      const response: any = await ApiService.getPost(`vehicle/get-vehicle?contactNumber=${contactNumber}&page=${page}&limit=10`, "");
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public async getPointsOfVehicleOwner(userId: number, page: number): Promise<any> {
    try {
      const response: any = await ApiService.getPost(`payment/point/${userId}?page=${page}&limit=10`, "");
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public async deleteVechileOwner(id: any): Promise<any> {
    try {
      const response: any = await ApiService.deletePost(`users/${id}`, "");
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public async rejectDeletionRequest(id: any, values: any): Promise<any> {
    try {
      const response: any = await ApiService.setPost(`users/reject-deletion/${id}`, values);
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public async updateVechileOwner(id: any, values: any): Promise<any> {
    try {
      const response: any = await ApiService.updatePost(`users/${id}`, values);
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }

  // Driver
  public async getAllDriver(page: number, input: string, filter: string, report: string, limit?: number): Promise<any> {
    try {
      let baseUrl = `users/drivers?page=${page ?? 1}`;
      if (limit) {
        baseUrl += `&limit=${limit}`;
      }
      if (input) {
        baseUrl += `&search=${input}`;
      }
      if (filter) {
        baseUrl += `&${filter}`;
      }
      if (report) {
        baseUrl += `&${report}`;
      }
      const response: any = await ApiService.getPost(baseUrl, "");
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public async getADriver(id: any): Promise<any> {
    try {
      const response: any = await ApiService.getPost(`users/driver/${id}`, "");
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public async createDriver(values: any): Promise<any> {
    try {
      const response: any = await ApiService.setPost("users/driver", values);
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public async deleteDriver(id: any): Promise<any> {
    try {
      const response: any = await ApiService.deletePost(`users/driver/${id}`, "");
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public async updateDriver(id: any, values: any): Promise<any> {
    try {
      const response: any = await ApiService.updatePost(`users/driver/${id}`, values);
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public async getAllShipper(page: number, input: string, filter: string, accountStatus: string, report?: string): Promise<any> {
    try {
      let baseUrl = `users/shipper/list?page=${!!page ? page : 1}`;
      if (!!page) {
        baseUrl += `&limit=10`;
      }
      if (input) {
        baseUrl += `&search=${input}`;
      }
      if (filter) {
        baseUrl += `&${filter}`;
      }
      if (accountStatus) {
        baseUrl += `&accountStatus=${accountStatus}`;
      }
      if (report) {
        baseUrl += `&${report}`;
      }
      const response: any = await ApiService.getPost(baseUrl, "");
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public async getAShipper(id: any): Promise<any> {
    try {
      const response: any = await ApiService.getPost(`users/${id}`, "");
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public async createShipper(values: any): Promise<any> {
    try {
      const response: any = await ApiService.setPost("users", values);
      return response;
    } catch (error) {
      return error;
      // Promise.reject(error);
    }
  }

  public async deleteShipper(id: any): Promise<any> {
    try {
      const response: any = await ApiService.deletePost(`users/${id}`, "");
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public async updateShipper(id: any, values: any): Promise<any> {
    try {
      const response: any = await ApiService.updatePost(`users/${id}`, values);
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }
  // Hash Key
  public async getHashKey(): Promise<any> {
    try {
      const response: any = await ApiService.getPost("auth/hash", "");
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public async generateNewHash(): Promise<any> {
    try {
      const response: any = await ApiService.setPost("auth/tqms-hash", "");
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }

  // Contract
  public async getContract(
    type: string,
    page: number,
    limit?: number,
    search?: string,
    filter?: string,
  ): Promise<any> {
    try {
      let url = `order/contract?type=${encodeURIComponent(type)}`;

      if (page !== undefined && !isNaN(page)) {
        url += `&page=${page}&limit=${limit || 10}`;
      }

      if (search?.trim()) {
        url += `&search=${encodeURIComponent(search.trim())}`;
      }

      if (filter?.trim()) {
        url += `&${filter}`;
      }

      const response: any = await ApiService.getPost(url, "");
      return response?.data;
    } catch (error) {
      throw error;
    }
  }

  public async getContractById(id: number): Promise<any> {
    try {
      const response: any = await ApiService.getPost(`order/contract/${id}`, "");
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public async generateContract(values: any): Promise<any> {
    try {
      const response: any = await ApiService.setPost("order/contract", values);
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }

  // Dgital Contract Key
  public async getDigitalContract(): Promise<any> {
    try {
      const response: any = await ApiService.getPost("order/digital-contract", "");
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public async generateDigitalContract(values: any): Promise<any> {
    try {
      const response: any = await ApiService.setPost("order/digital-contract", values);
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }
  public async assignDriver(values: any): Promise<VehicleInfo> {
    try {
      const response: any = await ApiService.setPost("vehicle/assign-driver", values);
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async getDashboard(role: "ROLE_VEHICLE_OWNER" | "ROLE_PLATFORM" | "ROLE_SHIPPER" | "ROLE_STAFF" | "ROLE_OTHER"): Promise<any> {
    try {
      const response: any = await ApiService.getPost(`dashboard${role === "ROLE_VEHICLE_OWNER" ? "/vehicle-owner" : role === "ROLE_PLATFORM" ? "/platform-admin" : role === "ROLE_SHIPPER" ? "/shipper" : role === "ROLE_STAFF" ? "/staff" : ""}`, "");
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }
  public async addNewRoles(values: any): Promise<any> {
    try {
      const response: any = await ApiService.setPost("roles", values);
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async deleteRole(id: number): Promise<any> {
    try {
      const response: any = await ApiService.deletePost(`roles/${id}`, "");
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async getShipmentTrackingReport(trackingNumber: any): Promise<any> {
    try {
      const response = await ApiService.getPost(`order/shipper/report/v2?search=${trackingNumber}`, "");
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async getShipmentCalendarReport(date: string): Promise<any> {
    try {
      const response = await ApiService.getPost(`order/shipper/calendar-report/v2?date=${date}`, "");
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async getShipmentDispatchReport(page: number, input: string, filter: string): Promise<any> {
    try {
      let url = `order/shipper/dispatch-report/v2`;

      if (page > 0) {
        url += `?page=${page}&limit=10`;
      }

      if (input) {
        url += `${page > 0 ? "&" : "?"}search=${input}`;
      }

      if (filter) {
        url += `${page > 0 || input ? "&" : "?"}${filter}`;
      }

      const response: any = await ApiService.getPost(url, "");
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async acceptTermsWithoutToken(values: any): Promise<User | any> {
    try {
      const response: any = await ApiService.setPost("auth/user-tc-agree", values);
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  //skipped additional information
  public async getSkippedAdditionalInfo(): Promise<User> {
    try {
      const response: any = await ApiService.getPost("users/skip-additional-info", "");
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  }
  public async setEstimatedPriceRule(values: any): Promise<any> {
    try {
      const response: any = await ApiService.setPost("order/estimate-price", values);
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }
  public async getEstimatedPriceRule(): Promise<any> {
    try {
      const response: any = await ApiService.getPost("order/estimate-price", "");
      return response?.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }
  public async updateEstimatedPriceRule(): Promise<any> {
    try {
      const response: any = await ApiService.getPost("order/apply-estimated-fare", "");
      return response?.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  // Vehicle Owner
  public async getAllVechileOwnerV2(): Promise<any> {
    try {
      const response: any = await ApiService.getPost("/auth/vehicle-owners/v2", "");
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public async getAllNewVehicleOwnerData(page: number, input: string, filter: string, report: string): Promise<any> {
    try {
      const response: any = await ApiService.getPost(page > 0 ? `/auth/vehicle-owners/v3?page=${page}&limit=10${input ? `&search=${input}` : ""}${filter ? `&${filter}` : ""}${report}` : `auth/vehicle-owners/v3${filter ? `?${filter}` : ""}${report}`, "");
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }

  //Order Matching Criteria
  public async getOrderMatchingCriteria(): Promise<any> {
    try {
      const response: any = await ApiService.getPost("order/matching-criteria", "");

      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public async updateOrderMatchingCriteria(criteriaId: number, values: any): Promise<any> {
    try {
      const response: any = await ApiService.updatePost(`order/matching-criteria/${criteriaId}`, values);
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }

  //Subscription Feaure Plan
  public async getSubscriptionPlan(): Promise<any> {
    try {
      const response: any = await ApiService.getPost("subscription/subscription-plans", "");
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }
  public async getAllFeatures(): Promise<any> {
    try {
      const response: any = await ApiService.getPost("subscription/plan-features", "");
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }
  public async updatePlanActiveStatus(id: any, values: any): Promise<any> {
    try {
      const response: any = await ApiService.updatePost(`subscription/plan/${id}`, values);
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public async updatePlanVATPrice(id: any, values: any): Promise<any> {
    try {
      const response: any = await ApiService.updatePost(`subscription/plan-price/${id}`, values);
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public async getSubscriptionPlanDetails(id: any): Promise<any> {
    try {
      const response: any = await ApiService.getPost(`subscription/plan/${id}`, "");
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public async updateGracePeriod(id: any, values: any): Promise<any> {
    try {
      const response: any = await ApiService.setPost(`subscription/grace-period/${id}`, values);
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public async getPlanPrice(): Promise<any> {
    try {
      const response: any = await ApiService.getPost("subscription/plan-price", "");
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public async initiateSubscriptionPayment(values: any): Promise<any> {
    try {
      const response: any = await ApiService.setPost("subscription/payment/v2", values);
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public async updateSubscriptionPayment(vehicleId: any, values: any): Promise<any> {
    try {
      const response: any = await ApiService.updatePost(`subscription/temporary-upgrade/v2/${vehicleId}`, values);
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }

  //Contract Owner
  public async updateContractOwner(id: any, values: any): Promise<any> {
    try {
      const response: any = await ApiService.updatePost(`users/contract-owner/${id}`, values);
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }

  //Contract Shipper
  public async updateContractShipper(id: any, values: any): Promise<any> {
    try {
      const { _isActivate, ...payload } = values;
      const response: any = _isActivate ? await ApiService.setPost(`users/contract-shipper/${id}`, payload) : await ApiService.updatePost(`users/contract-shipper/${id}`, payload);
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public async getCoolingPeriods(): Promise<any> {
    try {
      const response: any = await ApiService.getPost("/users/cooling-period", "");
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async updateCoolingPeriod(coolingPeriodId: number, value: number): Promise<any> {
    try {
      const response: any = await ApiService.updatePost(`/users/cooling-period/${coolingPeriodId}`, { value });
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async unlockUser(userId: number): Promise<any> {
    try {
      const response: any = await ApiService.getPost(`users/reset-cooling-period/${userId}`, "");
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async getTaxRate(): Promise<any> {
    try {
      const response: any = await ApiService.getPost("/payment/tax-rate", "");
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async updateTaxRate(values: { rate: number; taxable: boolean }): Promise<any> {
    try {
      const response: any = await ApiService.updatePost("/payment/tax-rate", values);
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async getPromotions(page: number, input?: string, filter?: string): Promise<any> {
    try {
      let url = `promotion/promo-code`;

      if (page > 0) {
        url += `?page=${page}&limit=10`;
      }

      if (input) {
        url += `${page > 0 ? "&" : "?"}search=${input}`;
      }

      if (filter) {
        url += `${page > 0 || input ? "&" : "?"}${filter}`;
      }

      const response: any = await ApiService.getPost(url, "");
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async updatePromotionStatus(promotionId: number, data: any): Promise<any> {
    try {
      const response: any = await ApiService.updatePost(`/promotion/promo-code/${promotionId}`, data);
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async sendPromotionAlert(promotionId: number, alertTypes: string[]): Promise<any> {
    try {
      const response: any = await ApiService.setPost(`/promotion/send-promo-code/${promotionId}`, { alertTypes });
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async createPromotion(values: any): Promise<any> {
    try {
      const response: any = await ApiService.setPost("promotion/promo-code", values);
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async updatePromotion(promotionId: number, values: any): Promise<any> {
    try {
      const response: any = await ApiService.updatePost(`promotion/promo-code/${promotionId}`, values);
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async getPromotion(promotionId: number): Promise<any> {
    try {
      const response: any = await ApiService.getPost(`promotion/promo-code/${promotionId}`, "");
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async getAllContents(page: number, input: string, filter: string): Promise<any> {
    try {
      const response: any = await ApiService.getPost(page > 0 ? `/content?page=${page}&limit=10${input ? `&search=${input}` : ""}${filter ? `&${filter}` : ""}` : `content${filter ? `?${filter}` : ""}`, "");
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async getAContent(id: any): Promise<any> {
    try {
      const response: any = await ApiService.getPost(`content/${id}`, "");
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public async createContent(values: any): Promise<any> {
    try {
      const response: any = await ApiService.setPost("content", values);
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public async updateContent(id: number, values: any): Promise<any> {
    try {
      const response: any = await ApiService.updatePost(`content/${id}`, values);
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public async deleteContent(id: number): Promise<any> {
    try {
      const response: any = await ApiService.deletePost(`content/${id}`, "");
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public async updateUserPoint(userId: number, point: number, paymentMethod: string): Promise<any> {
    try {
      const response: any = await ApiService.setPost("payment/point", { userId, transactionAmount: point, paymentMethod });
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async getPointRefundDetail(): Promise<any> {
    try {
      const response: any = await ApiService.getPost("payment/refundable-point", "");
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async getPointRefundRequests(page: number, input: string, filter: string): Promise<any> {
    try {
      let url = `payment/point-refund-request`;
      if (page > 0) {
        url += `?page=${page}&limit=10`;
      }
      if (input) {
        url += `${page > 0 ? "&" : "?"}search=${input}`;
      }
      if (filter) {
        url += `${page > 0 || input ? "&" : "?"}${filter}`;
      }

      const response: any = await ApiService.getPost(url, "");
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async getAwaitingAccountApproval(page: number, input?: string, filter?: string): Promise<any> {
    try {
      let url = `users/account-approval`;

      if (page > 0) {
        url += `?page=${page}&limit=10`;
      }

      if (input) {
        url += `${page > 0 ? "&" : "?"}search=${input}`;
      }

      if (filter) {
        url += `${page > 0 || input ? "&" : "?"}${filter}`;
      }

      const response: any = await ApiService.getPost(url, "");
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async pointRefundRequestAction(id: number, status: string, reason?: string): Promise<any> {
    try {
      const response: any = await ApiService.setPost(`payment/point-refund-request/${id}`, { status, reason });
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async getPointTransactionLogs(page: number, input: string, filter: string, limit?: number): Promise<any> {
    try {
      const queryParams: string[] = [];
      if (page > 0) {
        queryParams.push(`page=${page}`);
        queryParams.push(`limit=${limit ?? 10}`);
      } else if (limit) {
        queryParams.push(`limit=${limit}`);
      }
      if (input) {
        queryParams.push(`search=${input}`);
      }
      if (filter) {
        queryParams.push(filter);
      }

      const url = `payment/point-transaction${queryParams.length ? `?${queryParams.join("&")}` : ""}`;
      const response: any = await ApiService.getPost(url, "");
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async pointRefundRequestThunk(amount: number): Promise<any> {
    try {
      console.log(amount);
      const response: any = await ApiService.setPost(`payment/refund-request`, { amount });
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async updateAccountApprovalStatus(userId: number, status: "approved" | "rejected" | string): Promise<any> {
    try {
      const response: any = await ApiService.setPost(`users/account-approval/${userId}`, { status });
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async updateShipperTripAccess(userId: number, tripAccess: boolean): Promise<any> {
    try {
      const response: any = await ApiService.setPost(`users/trip-access`, { userId, tripAccess });
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async updateShipperPermission(userId: number, permission: string, status: boolean): Promise<any> {
    try {
      const response: any = await ApiService.setPost(`users/shipper-permission`, { userId, permission, status });
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async getPaymentCommission(page: number, search: string): Promise<any> {
    try {
      let url = `payment/payment-partners`;
      if (page > 0) {
        url += `?page=${page}&limit=10`;
      }
      if (search) {
        url += `${page > 0 ? "&" : "?"}search=${search}`;
      }

      const response: any = await ApiService.getPost(url, "");
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async updatePaymentCommissionStatus(paymentPartnerId: number, status: boolean): Promise<any> {
    try {
      const url = `payment/payment-partner/status/${paymentPartnerId}`;
      const response: any = await ApiService.updatePost(url, { status });
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async updatePaymentCommission(paymentPartnerId: number, values: any): Promise<any> {
    try {
      const url = `payment/payment-partner/${paymentPartnerId}`;
      const response: any = await ApiService.updatePost(url, values);
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async getContractHistory($userId: number, page: number, limit: number): Promise<any> {
    try {
      let url = `users/contract-history/${$userId}`;
      if (page > 0) {
        url += `?page=${page}&limit=${limit ?? 10}`;
      }

      const response: any = await ApiService.getPost(url, "");
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async getDeleteRequestedDriver(page: number, search: string, filter: string): Promise<any> {
    try {
      let url = `users/delete-requested?userRole=DRIVER`;
      if (!!page) {
        url += `&page=${page}&limit=10`;
      }
      if (!!search) {
        url += `&search=${search}`;
      }
      if (!!filter) {
        url += `&${filter}`;
      }

      const response: any = await ApiService.getPost(url, "");
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async getDeleteRequestedVehicleOwner(page: number, search: string, filter: string): Promise<any> {
    try {
      let url = `users/delete-requested?userRole=VEHICLE_OWNER`;
      if (!!page) {
        url += `&page=${page}&limit=10`;
      }
      if (!!search) {
        url += `&search=${search}`;
      }
      if (!!filter) {
        url += `&${filter}`;
      }

      const response: any = await ApiService.getPost(url, "");
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async getServerLogDataThunk(page: number, limit: number, search: string, filter: string): Promise<any> {
    try {
      let url = `vehicle/rejected-data`;
      if (!!page) {
        url += `?page=${page}&limit=${!!limit ? limit : 10}`;
      }
      if (!!search) {
        url += `&search=${search}`;
      }
      if (!!filter) {
        url += `&${filter}`;
      }

      const response: any = await ApiService.getPost(url, "");
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  }
}

export default UserRepository;
